export default __webpack_public_path__ + "static/media/arrowRight.62ab86f9.svg";